import TelepresenceQuickStartLanding from "../../../../ambassador-docs/docs/1.12/telepresence/quick-start/TelepresenceQuickStartLanding";
import * as React from 'react';
export default {
  TelepresenceQuickStartLanding,
  React
};